import { render, staticRenderFns } from "./PersonalInfoTabs.vue?vue&type=template&id=70177e55&scoped=true&"
import script from "./PersonalInfoTabs.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoTabs.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoTabs.vue?vue&type=style&index=0&id=70177e55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70177e55",
  null
  
)

export default component.exports